/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_Q4Inputs */

const en_guide_what_is_json_faq_q4 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is JSON case sensitive?`)
};

const ko_guide_what_is_json_faq_q4 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 대소문자를 구분하나요?`)
};

const ja_guide_what_is_json_faq_q4 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON は大文字と小文字を区別しますか?`)
};

/**
* | output |
* | --- |
* | "Is JSON case sensitive?" |
*
* @param {Guide_What_Is_Json_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_q4 = /** @type {((inputs?: Guide_What_Is_Json_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_q4(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_q4(inputs)
	return ja_guide_what_is_json_faq_q4(inputs)
});